export default "<div id=\"chartdiv\" style=\"fill: #536f8a !important;\"></div>";